import * as getters from "./routes.getters";
import * as actions from "./routes.actions";
import * as mutations from "./routes.mutations";

import transportModesDefaults from "@data/transportModesDefaults";

const state = {
    routeWaypoints: [],
    transportModes: transportModesDefaults,
    activeTransportModeTab: false,
    manualTransportModes: [],
    routesLoading: false,
    activeRouteId: '',
    activeRouteMode: false,
    detailRouteId: false,
    routeCorridor: false,
    routeShortTermParkingZone: {},
    routeCountryInfos: {},
    routeGreenzones: {},
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}